import BaseModel from "./BaseModel";
import {getDocs, limit, orderBy, query, where, startAt} from "firebase/firestore";
import ShopifySite from "./ShopifySite";
import CategoryMapping from "./CategoryMapping";
import ShopifyProduct from "./ShopifyProduct";
import SiteCollectionMapping from "./SiteCollectionMapping";

export default class PotentialShopifySite extends BaseModel {
    static data_name = 'potential_shopify_sites';

    static ApprovalState = {
        NOT_SET: 0,
        REJECTED: 1,
        MAYBE: 2,
        APPROVED: 3,
        KIDS: 4,

        name(state){
            switch (state){
                case this.APPROVED: return "Approved";
                case this.REJECTED: return "Rejected";
                case this.MAYBE: return "Maybe";
                case this.KIDS: return "Kids";
                default: return "Not Set";
            }
        },

        color(state){
            switch (state){
                case this.APPROVED: return "#0e8d0e";
                case this.REJECTED: return "#ff0000";
                case this.MAYBE: return "#ffff00";
                case this.KIDS: return "#00ffff";
                default: return "#333333";
            }
        }
    };



    async updateShopifyMetaData(meta){
        for (const [key, value] of Object.entries(meta)) {
            this[`shopify_${key}`] = value;
        }
        this.api_url = "https://" + meta.myshopify_domain;
        this.currency_symbol = this.shopify_money_format
            .replace(this.shopify_currency, "")
            .replace(/({([^>]+)})/ig, "")
            .replace(/(<([^>]+)>)/ig, "")
            .trim();
        await this.save();
    }

    get approval_state_name(){
         return this.constructor.ApprovalState.name(this.approval_state);
    }

    get approval_state_color(){
        return this.constructor.ApprovalState.color(this.approval_state);
    }

    get ships_to_australia(){
        return this.shopify_ships_to_countries.includes("AU");
    }

    get ships_to_usa(){
        return this.shopify_ships_to_countries.includes("US");
    }

    get category_mapping_objects(){
        if(this.category_mappings == undefined || this.category_mappings == null) return [];
        return this.category_mappings.map( mapping => CategoryMapping.fromData(mapping));
    }

    async loadSiteCollectionMapping(){
        this._site_collection_mapping = await SiteCollectionMapping.get(this.document_id);
    }

    mappingCollectionsForProductHandle(product_handle){
        return this._site_collection_mapping.collections.filter( u => u.product_handles.includes(product_handle));
    }

    async approveSite(){
        this.validateHandle();
        let siteExists = await ShopifySite.exists(this.handle);
        if(siteExists)
            throw 'Site with this handle already exists.';
        let shopify_site = await ShopifySite.instanceFromPotentialShopifySite(this);
        this.shopify_site_document_id = shopify_site.document_id;
        this.approval_state = this.constructor.ApprovalState.APPROVED;
        this.weighting = 100;
        await this.save();
        return shopify_site;
    }

    validateHandle(){
        if(this.handle.length < 3)
            throw 'handle must be at least 3 characters';
        if(this.handle !== this.handle.toLowerCase())
            throw 'handle must be lowercase';
        if (/\s/.test(this.handle))
            throw 'handle cannot contain spaces';
        if(!(/^[a-zA-Z0-9_.-]*$/.test(this.handle)))
            throw 'Invalid handle';
    }

    addCategoryMapping(){
        this.category_mappings.push({
            field: "a",
            value: "b",
            category: "c",
            subcategory: "d"
        });
        console.log("this.category_mappings", this.category_mappings)
    }

    static instanceFromCsvLine(csv_obj){
        let instance = new this();
        Object.assign(instance, csv_obj);
        instance.document_id = csv_obj.domain;
        instance.approval_state = this.ApprovalState.NOT_SET;
        instance.product_types = [];
        instance.category_mappings = [];
        instance.main_image_index = 0;
        instance.alexa_rank = parseInt(instance.alexa_rank);
        instance.platform_rank = parseInt(instance.platform_rank);
        instance.rank = parseInt(instance.rank);
        instance.common_crawl_pagerank = parseInt(instance.common_crawl_pagerank);

        instance.shopify_id = "";
        instance.shopify_name = "";
        instance.shopify_city = "";
        instance.shopify_province = "";
        instance.shopify_country = "";
        instance.shopify_currency = "";
        instance.shopify_domain = "";
        instance.shopify_url = "";
        instance.shopify_myshopify_domain = "";
        instance.shopify_description = "";
        instance.shopify_ships_to_countries = [],
        instance.shopify_money_format = "";
        instance.shopify_published_collections_count = 0;
        instance.shopify_published_products_count = 0;
        instance.shopify_shopify_pay_enabled_card_brands = [];

        instance.name = "";
        instance.handle = "";
        instance.api_url = "";
        instance.currency_symbol = "";
        instance.shopify_site_document_id = "";
        instance.created_at = new Date();

        return instance;
    }

    static async approvalPage(approval_state, start_at = Number.MAX_SAFE_INTEGER) {
        const q = query(this.collectionRef,
            where('approval_state', '==', approval_state),
            orderBy('alexa_rank',  'desc'),
            limit(100),
            startAt(start_at)
        );
        const querySnapshot = await getDocs(q);
        return querySnapshot.docs.map(doc => this.instanceFromDocument(doc));
    }

    static async getByHandle(handle){
        return this.getBy('handle', handle);
    }

    categoryMappingForProductType(product_type){
        let escaped_product_type = product_type.toLowerCase().replace(/\s+/g, " ").trim();
        let mapping = this.category_mappings.find( mapping => mapping.field == 'product_type' && mapping.value == escaped_product_type);
        if(mapping) {
            return { category: mapping.category, subcategory: mapping.subcategory, display_state: mapping.display_state };
        }else{
            return { category: null, subcategory: null, display_state: ShopifyProduct.DisplayState.NOT_SET };
        }
    }


}